var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93995 8.00002L11.3333 5.62669C11.4606 5.49762 11.5314 5.32326 11.5301 5.14197C11.5289 4.96069 11.4557 4.78732 11.3266 4.66002C11.1975 4.53272 11.0232 4.4619 10.8419 4.46315C10.6606 4.4644 10.4872 4.53762 10.3599 4.66669L7.99995 7.06002L5.63995 4.71335C5.51504 4.58919 5.34607 4.51949 5.16995 4.51949C4.99382 4.51949 4.82485 4.58919 4.69995 4.71335C4.63746 4.77533 4.58786 4.84906 4.55402 4.9303C4.52017 5.01154 4.50275 5.09868 4.50275 5.18669C4.50275 5.2747 4.52017 5.36183 4.55402 5.44307C4.58786 5.52431 4.63746 5.59805 4.69995 5.66002L7.05995 8.00002L4.66661 10.3734C4.53931 10.5024 4.46849 10.6768 4.46974 10.8581C4.47099 11.0394 4.54421 11.2127 4.67328 11.34C4.80235 11.4673 4.97671 11.5381 5.15799 11.5369C5.33928 11.5356 5.51264 11.4624 5.63995 11.3334L7.99995 8.94002L10.3599 11.2867C10.4849 11.4109 10.6538 11.4805 10.8299 11.4805C11.0061 11.4805 11.175 11.4109 11.2999 11.2867C11.3624 11.2247 11.412 11.151 11.4459 11.0697C11.4797 10.9885 11.4971 10.9014 11.4971 10.8134C11.4971 10.7253 11.4797 10.6382 11.4459 10.557C11.412 10.4757 11.3624 10.402 11.2999 10.34L8.93995 8.00002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b6c4ef0b7d25298e759a26060b34e2ed.svg";
export { ForwardRef as ReactComponent };